












import { GetTayehMarketplaceShopResponse } from "@/classes/TayehApi/TyMarketplace";
import { Component, Prop, Vue } from "vue-property-decorator";
import MarketplaceImage from "./MarketplaceImage.vue";

    @Component({
        components: {
            MarketplaceImage
        }
    })
    export default class MarketplaceShopCard extends Vue {
        @Prop() shop: GetTayehMarketplaceShopResponse;
    }
